// extracted by mini-css-extract-plugin
export default {"skipLinksRegion":"skip_links_region-module___skipLinksRegion___dfad6f44"};